import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';

import * as Sentry from "@sentry/angular";

if (environment.sentry?.enabled) {
  const appUrlPattern = new RegExp(`^${environment.appUrl.replace(/\./g, '\\.')}`);

  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment ?? 'unknown',
    integrations: [],
    tracePropagationTargets: [appUrlPattern],
    ignoreErrors: [
      // Browser extension noise (translators, password managers, ad blockers, etc.)
      'Invalid call to runtime.sendMessage()',
      'Extension context invalidated',
      'chrome-extension://',
      'moz-extension://',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // NgbModal dismiss (ESC / backdrop click) rejects `.result` with a non-Error reason;
      // Sentry's ErrorHandler can't extract a message from it and falls back to this generic string.
      'Handled unknown error',
    ],
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
      /^safari-web-extension:\/\//i,
    ],
  });
}

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap().catch(err => console.log(err));
}
